import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUser = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 8C8 10.5 9.8 12.5 12 12.5C14.2 12.5 16 10.5 16 8V7C16 4.5 14.2 2.5 12 2.5C9.8 2.5 8 4.5 8 7V8ZM9 7C9 5.1 10.3 3.5 12 3.5C13.7 3.5 15 5.1 15 7V8C15 9.9 13.7 11.5 12 11.5C10.3 11.5 9 9.9 9 8V7Z'
    />
    <path d='M3.5 21.5V18.5C3.5 16.1 5.5 13.3 8 13.3C8.3 13.3 8.5 13.5 8.5 13.8C8.5 14.1 8.3 14.3 8 14.3C6.1 14.3 4.5 16.6 4.5 18.5V20.5H19.5V18.5C19.5 16.6 17.9 14.3 16 14.3C15.7 14.3 15.5 14.1 15.5 13.8C15.5 13.5 15.7 13.3 16 13.3C18.5 13.3 20.5 16.1 20.5 18.5V21.5H3.5Z' />
  </svg>
);
export default SvgUser;
